import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';

export const showChatSlice = createSlice({
  name: 'showChat',
  initialState: {
    chat: false,
  },
  reducers: {
    openChat: (state) => {
      state.chat = true;
    },
    closeChat: (state) => {
      state.chat = false;
    },
  },
});

export const { openChat, closeChat } = showChatSlice.actions;
export const getChatComponentState = (state: RootState) => state.showChat.chat;
export default showChatSlice.reducer;
